import { ListGroupItem } from "react-bootstrap";
import {
    BsBattery,
    BsBatteryCharging,
    BsBatteryFull,
    BsBatteryHalf,
} from "react-icons/bs";
import { Link } from "react-router";

import { useMissionDocument } from "../../api/firestoreWrappers.generated";
import EmergencyLandSlider from "../../components/EmergencyLandSlider";
import UserQuestion from "../../components/UserQuestion";

export default function DroneCard({
    name,
    droneState,
    organizationId,
    locationId,
    showSlider = false,
    stateColor,
    state,
    offline,
    to,
}) {
    const lastActiveMissionId = droneState?.missions?.reduce(
        (oldest, mission) =>
            !oldest || mission.timestamp < oldest.timestamp ? mission : oldest,
        null,
    )?.missionId;
    const [activeMission] = useMissionDocument(
        organizationId,
        locationId,
        lastActiveMissionId,
    );
    const battery = droneState?.widgets?.battery?.data ?? -1;
    const charging = droneState?.widgets?.isCharging?.data ?? false;

    // Handle the display of the battery
    let icon = <BsBattery className="ms-2" style={{ marginTop: "-2px" }} />;
    let batteryTextColor = "text-danger";

    // TODO: Merge this logic with the logic in DroneBatteryStat
    if (battery < 20) {
        icon = <BsBattery className="ms-2" style={{ marginTop: "-2px" }} />;
        batteryTextColor = "text-danger";
    } else if (battery < 35) {
        icon = <BsBatteryHalf className="ms-2" style={{ marginTop: "-2px" }} />;
        batteryTextColor = "text-warning";
    } else {
        icon = <BsBatteryFull className="ms-2" style={{ marginTop: "-2px" }} />;
        batteryTextColor = "text-success";
    }

    // If charging, override the icon with a charging battery icon
    if (charging) {
        icon = (
            <BsBatteryCharging className="ms-2" style={{ marginTop: "-2px" }} />
        );
    }

    const cardContent = (
        <div
            className={`p-3 ${showSlider ? "pb-1" : ""} d-flex justify-content-between align-items-center`}
        >
            <div className={`align-self-center ${stateColor}`}>
                <h4 className="m-0 p-0">{name}</h4>
                <p className="m-0 p-0">{state}</p>
            </div>
            {!offline && (
                <div className={`align-self-center ${batteryTextColor}`}>
                    <h4>
                        {icon} {battery.toFixed()}%
                    </h4>
                </div>
            )}
        </div>
    );

    return (
        <ListGroupItem className="p-0">
            {to ? (
                <Link to={to} className="d-block text-decoration-none">
                    {cardContent}
                </Link>
            ) : (
                cardContent
            )}

            {showSlider && (
                <div className="px-3 pb-3 d-flex justify-content-center align-items-center">
                    <EmergencyLandSlider
                        drone={{ id: name }}
                        droneState={droneState}
                        small={true}
                    />
                </div>
            )}
            {activeMission && (
                <UserQuestion
                    organizationId={organizationId}
                    locationId={locationId}
                    mission={activeMission}
                    mini={true}
                />
            )}
        </ListGroupItem>
    );
}
